export default {"src":"/_next/static/media/zoom-in-white-32x32.551c4863.svg","height":32,"width":32};